exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#myModal .modal-dialog[data-v-4270bc47]{-webkit-transform:translateY(80%);transform:translateY(80%)}#myModal .modal-content[data-v-4270bc47]{border:5px solid #fabb3d;border-radius:5px;padding:10px;font-size:25px;text-align:center}#myModal .modal-content .modal-header[data-v-4270bc47]{background:#f5f5f5}#myModal .modal-content .modal-title[data-v-4270bc47]{margin:auto;text-align:center;font-size:30px;color:#3da3fa}#myModal .modal-content .close[data-v-4270bc47]{text-align:right;position:absolute;top:-15px;right:-15px;background:#3da3fb;opacity:1;color:#fff;padding:3px 8px 8px;border-radius:16px;font-size:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4270bc47","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/views/Dashboard.vue
// module id = 8LVT
// module chunks = 1